export function getComponentType(name) {
    switch (name) {
        case 'PublicWebNavigationCategoryV2': {
            return 'category';
        }
        case 'PublicWebNavigationImageListCategoryV2': {
            return 'imageListCategory';
        }
        case 'PublicWebNavigationLinkV2':
        case 'PublicWebNavigationLink': {
            return 'link';
        }
        default: {
            return 'link';
        }
    }
}
